import React, { FC, useRef } from 'react';
import clsx from 'clsx';
import DropDown from '~/components/Menu/DropDown';
import DropDownItem from '~/components/Menu/DropDownItem';
import { TooltipEllipsis } from 'components/Tooltip';
import './style.scss';

interface ViewProps {
  label: string;
  viewKey: string;
  onClick?: (viewKey: string) => void;
  handleViewRename: () => void;
  handleViewDelete?: () => void;
  viewActive?: string;
}

const View: FC<ViewProps> = ({ viewKey, onClick, label, viewActive, handleViewRename, handleViewDelete }) => {
  const ref = useRef<HTMLElement>(null);
  return (
    <div className="view-button">
      <button
        className={clsx('button-clear', { active: viewKey === viewActive })}
        onClick={() => onClick && onClick(viewKey)}>
        <TooltipEllipsis title={label} className="view-name" />
      </button>
      <DropDown outsideRef={ref} openedIcon="menu" closedIcon="menu_open" className="more_views">
        <DropDownItem icon="edit" onClick={() => handleViewRename()}>
          Rename
        </DropDownItem>
        <DropDownItem icon="delete" onClick={() => handleViewDelete && handleViewDelete()} disabled={!handleViewDelete}>
          Delete
        </DropDownItem>
      </DropDown>
    </div>
  );
};

export default View;
